import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { updateSection } from "../../../assignmentSlice";

import { getContentHeight } from "../../../../../utils/textUtils";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import ArrowButton from "../../widgets/ArrowButton";
import VocaStudyPage from "./VocaStudyPage";
import VocaMatchingPage from "./VocaMatchingPage";
import VocaTestPage from "./VocaTestPage";

const VocabularyPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);
  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentPage = pageList[currentIndex] || { type: "", data: [] };

  useEffect(() => {
    if (pageList.length > 0) return;
    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    let tempPageList = [];
    let words = [];
    if (Array.isArray(section.question.data[0])) {
      words = section.question.data.map((element) => {
        return { eng: element[0], kor: element[1] };
      });
    } else {
      words = section.question.data.map((element) => {
        return { eng: element.eng, kor: element.kor };
      });
    }

    for (let i = 0; i < Math.ceil(words.length / 10); i++) {
      tempPageList.push({
        type: "study",
        data: words.slice(i * 10, (i + 1) * 10).map((word) => {
          return { ...word, isOpened: false };
        }),
      });
    }

    for (let i = 0; i < Math.ceil(words.length / 5); i++) {
      tempPageList.push({
        type: "matching",
        data: words.slice(i * 5, (i + 1) * 5).map((word) => {
          return { ...word, isMatched: false };
        }),
        isSubmitted: false,
      });
    }

    const testList = words.slice().map((word) => {
      return {
        text: word.eng,
        options: [
          ...words
            .slice()
            .filter((w) => w.kor !== word.kor)
            .sort(() => Math.random() - 0.5)
            .slice(0, 3)
            .map((word) => word.kor),
          word.kor,
        ].sort(() => Math.random() - 0.5),
        input: [],
        answer: word.kor,
      };
    });

    testList.forEach((element) => {
      tempPageList.push({
        type: "test",
        data: element,
        isSubmitted: false,
      });
    });

    setPageList(tempPageList);
  }, [section]);

  const handlePrev = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      let isAllAnswered = true;
      pageList.forEach((page) => {
        if (page.type === "test") {
          if (page.isSubmitted === false) {
            isAllAnswered = false;
            return;
          }
        } else if (page.type === "matching") {
          if (page.isSubmitted === false) {
            isAllAnswered = false;
            return;
          }
        }
      });
      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          paddingRight: "20px",
          justifyContent: "space-between",
          height: getContentHeight(),
          fontFamily: '"Noto Sans KR", sans-serif',
          backgroundColor: "#FFFFFF",
        }}
      >
        <ArrowButton
          direction="left"
          onClick={() => handlePrev()}
          visibleCondition={currentIndex > 0}
        />
        {currentPage.type === "study" && (
          <VocaStudyPage
            currentPage={currentPage}
            setPageList={setPageList}
            currentIndex={currentIndex}
            type={"analysis"}
          />
        )}
        {currentPage.type === "matching" && (
          <VocaMatchingPage
            section={section}
            currentPage={currentPage}
            pageList={pageList}
            setPageList={setPageList}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            isReview={isReview}
            type={"analysis"}
          />
        )}
        {currentPage.type === "test" && (
          <VocaTestPage
            section={section}
            currentPage={currentPage}
            pageList={pageList}
            setPageList={setPageList}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            isReview={isReview}
          />
        )}
        <ArrowButton
          direction="right"
          onClick={() => handleNext()}
          visibleCondition={true}
        />
      </div>
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          height: "70px",
          width: "100vw",
          backgroundColor: "#F6F8FA", // 바 색상
          color: "#737373",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {currentIndex + 1} / {pageList.length}
      </div>
    </>
  );
};

export default VocabularyPage;
